const { initialState } = window;
const { data } = initialState;

data.search = {
	meta: {
		page: 1,
		totalPages: 0,
		term: "",
		loading: false
	},
	data: {
		games: [],
		sections: []
	}
};
data.menu.most_played = JSON.parse(data.menu.most_played);
data.juegos_destacados = data.juegos_destacados
	? JSON.parse(data.juegos_destacados)
	: { meta: {} };

data.juegos_destacados.react = [];
if (typeof data.juegos_destacados.meta.sortBy === "undefined") {
	data.juegos_destacados.meta.sortBy = "page";
	data.juegos_destacados.meta.loading = false;
	data.juegos_destacados.meta.loadingTimer = 0;
	data.juegos_destacados.meta.slug = "none";
	data.juegos_destacados.data = data.juegos_destacados.data
		? data.juegos_destacados.data
		: [];
}

data.gamelauncher = data.gamelauncher
	? JSON.parse(data.gamelauncher)
	: undefined;
data.games_played = {
	games:
		localStorage.getItem("games_played") !== null
			? JSON.parse(localStorage.getItem("games_played"))
			: [],
	played_games_items: []
};
data.games_favorites = {
	games:
		localStorage.getItem("games_favorites") !== null
			? JSON.parse(localStorage.getItem("games_favorites"))
			: [],
	favorites_games_items: []
};
data.games_played.games.forEach((el, index) => {
	if (typeof el.id === "number") {
		data.games_played.games[index].id = el.id;
	}
	data.games_played.games[index].img = el.img.replace("img_mobile", "img");
});

data.games_favorites.games.forEach((el, index) => {
	if (typeof el.id === "number") {
		data.games_favorites.games[index].id = el.id.toString();
	}
	data.games_favorites.games[index].img = data.games_favorites.games[
		index
	].img.replace("img_mobile", "img");
});
export default (state = data, action) => {
	switch (action.type) {
		case "MENU_LOAD_CATEGORIES":
			return {
				...state,
				...state,
				menu: {
					...state.menu,
					most_played_items: action.payload.items
				}
			};
		case "MENU_LOAD_PLAYED_GAMES":
			return {
				...state,
				...state,
				games_played: {
					...state.games_played,
					played_games_items: action.payload.items
				}
			};
		case "MENU_LOAD_FAVORITE_GAMES":
			return {
				...state,
				...state,
				games_favorites: {
					...state.games_favorites,
					favorites_games_items: action.payload.items
				}
			};

		case "REMOVE_FAVORITE": {
			const { games } = state.games_favorites;
			const json = games.filter(el => el.id !== action.payload.id);

			localStorage.setItem("games_favorites", JSON.stringify(json));
			return {
				...state,
				...state,
				games_favorites: {
					...state.games_favorites,
					games: json,
					shouldUpdate: true
				}
			};
		}
		case "ADD_FAVORITE": {
			const { games } = state.games_favorites;
			const { id, url, name, img } = action.payload.game;
			games.push({
				id,
				url,
				name,
				img: img.replace("img_mobile", "img")
			});

			localStorage.setItem("games_favorites", JSON.stringify(games));
			return {
				...state,
				...state,
				games_favorites: {
					...state.games_favorites,
					games,
					shouldUpdate: true
				}
			};
		}
		case "FAVORITE_SHOULDNT_UPDATE": {
			return {
				...state,
				...state,
				games_favorites: {
					...state.games_favorites,
					shouldUpdate: false
				}
			};
		}

		case "ADS_FLOAT_UPDATE": {
			const { id } = action.payload;
			return {
				...state,
				...state,
				ads_floats: {
					...state.ads_floats,
					[id]: state.ads_floats[id] ? !state.ads_floats[id] : true
				}
			};
		}
		case "GAME_TUTORIAL_SET": {
			const { hasTutorial = true } = action.payload;
			return {
				...state,
				...state,
				gamelauncher: {
					...state.gamelauncher,
					hasTutorial
				}
			};
		}

		case "LINKOBFUSCATE_UPDATE_LINKS": {
			const { id } = action.payload;
			const newObject = {
				...state,
				...state,
				obfuscate: {
					...state.obfuscate,
					[id]: action.payload.data
				}
			};

			localStorage.setItem(
				"ofuscatedlinks",
				JSON.stringify(newObject.obfuscate)
			);

			return newObject;
		}
		case "PAGINATION_UPDATE_PAGE": {
			const { page } = action.payload;
			return {
				...state,
				...state,
				juegos_destacados: {
					...state.juegos_destacados,
					meta: {
						...state.juegos_destacados.meta,
						page
					}
				}
			};
		}
		case "SECTION_TOGGLE_LOADING": {
			const { slug = state.juegos_destacados.meta.slug } = action.payload;
			return {
				...state,
				...state,
				juegos_destacados: {
					...state.juegos_destacados,
					meta: {
						...state.juegos_destacados.meta,
						loading: !state.juegos_destacados.meta.loading,
						slug
					}
				}
			};
		}
		case "SEARCH_UPDATE": {
			const { meta, games, sections, page } = action.payload;
			return {
				...state,
				...state,
				search: {
					...state.search,
					meta: {
						...state.search.meta,
						...meta,
						page
					},
					data: {
						games,
						sections
					}
				}
			};
		}
		case "SEARCH_TOGGLE_LOADING": {
			const { term = state.search.meta.term } = action.payload;
			return {
				...state,
				...state,
				search: {
					...state.search,
					meta: {
						...state.search.meta,
						loading: !state.search.meta.loading,
						term
					}
				}
			};
		}
		case "GAME_SET_GAMELAUNCHER": {
			return {
				...state,
				...state,
				gamelauncher: {
					...action.payload.data,
					loading: true
				}
			};
		}
		case "GAME_SET_SAGA": {
			if (action.payload.data) {
				return {
					...state,
					...state,
					game_sagaGames: {
						...action.payload.data
					}
				};
			}
			return state;
		}
		case "GAME_SET_RELATED": {
			if (action.payload.data) {
				return {
					...state,
					...state,
					game_relatedGames: {
						...action.payload.data,
						requested: true
					}
				};
			}
			return state;
		}
		case "GAME_REMOVE_AD": {
			return { ...state, ...state, removeAd: true };
		}
		case "GAMES_PLAYED_ADD": {
			const { games, games_session } = state.games_played;
			if (games.filter(el => el.id == action.payload.game.id).length === 0) {
				if (games.length >= 10) {
					while (games.length >= 10) {
						games.pop();
					}
				}

				const { id, url, name, img } = action.payload.game;
				games.unshift({
					id,
					url,
					name,
					img: img.replace("img_mobile", "img")
				});
			}

			localStorage.setItem("games_played", JSON.stringify(games));
			return {
				...state,
				...state,
				games_played: {
					...state.games_played,
					games,
					games_session,
					shouldUpdate: true
				}
			};
		}
		case "GAMES_PLAYED_SHOULDNT_UPDATE": {
			return {
				...state,
				...state,
				games_played: {
					...state.games_played,
					shouldUpdate: false
				}
			};
		}
		case "ADS_RESET": {
			return {
				...state,
				...state,
				removeAd: false,
				loadingAd: true,
				loadingScreen: true,
				showGame: true
			};
		}
		case "CONTACT_RESET": {
			return {
				...state,
				...state,
				message: {
					status: "noshow",
					message: " "
				}
			};
		}
		case "CONTACT_SET_MESSAGE": {
			return {
				...state,
				...state,
				message: {
					status: action.payload.status,
					message: action.payload.message
				}
			};
		}
		case "TEXT_SET": {
			return { ...state, ...state, [action.payload.name]: action.payload.data };
		}
		case "ROTARJUEGOS_TOGGLE": {
			return { ...state, ...state, showGame: !state.showGame };
		}
		default:
			return state;
	}
};
